<div class="card elevation-2" (mouseleave)="onMouseLeave()">
  <div class="card-header d-flex align-items-center justify-content-between gap-5">
    <span class="si-title-2">{{ 'BROUTER_MAP.DATA.TITLE' | translate }}</span>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      [attr.aria-label]="'SHARED.CLOSE' | translate"
      (click)="closed.emit()"
    ></button>
  </div>

  @if (hasData()) {
    <ngx-datatable
      class="table-element route-data-table__table"
      columnMode="force"
      [rows]="rows()"
      [headerHeight]="32"
      [footerHeight]="0"
      [rowHeight]="28"
      [scrollbarV]="true"
      (activate)="onRowActivate($event)"
    >
      @for (column of columns(); track column.prop) {
        <ngx-datatable-column
          [prop]="'values.' + column.prop"
          [name]="column.name"
          [resizeable]="false"
          [sortable]="false"
        />
      }
    </ngx-datatable>
  } @else {
    <si-empty-state icon="element-list" [heading]="'BROUTER_MAP.DATA.NO_DATA' | translate" />
  }
</div>
